import { useEffect, useRef, useState } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { useDispatch, useSelector } from "react-redux"
import { fetchSocialAccountCreatorsThunk } from "slices/socialAccounts/thunk";
import { AppDispatch, RootState } from "store";
import { formatNumber, generateUniqueKey, getSocialAccountProfileURL } from "utils/helpers";
import userProfilePicture from "../../../assets/images/users/user-dummy-img.jpg";
import Skeleton from "react-loading-skeleton";
import IGLogoPNG from "../../../assets/images/brands/ig-logo.png"
import { setCreatorsFilters } from "slices/socialAccounts/reducer";
import { defaultSocialAccountCreatorsFilters } from "types/social-account";
import FollowersIcon from "assets/icons/mono/FollowersIcon";
import { UncontrolledTooltip } from "reactstrap";
import CreatorCard from "./CreatorCard";
const SocialAccountCreators: React.FC<{ socialAccountId: string }> = ({ socialAccountId }) => {

    const dispatch: AppDispatch = useDispatch();
    const filters = useSelector((state: RootState) => state.socialAccountState.creators.filters);
    const [filterId, setFilterId] = useState(generateUniqueKey(filters, ['page']));
    const [initialLoading, setInitialLoading] = useState(true);
    const debounceTimeout = useRef<NodeJS.Timeout | null>(null);
    const loading = useSelector((state: RootState) => state.socialAccountState.creators.loading);
    const creatorsData = useSelector((state: RootState) => state.socialAccountState.creators.items[socialAccountId!]?.filtered_lists?.[filterId!]);
    const hasMore = creatorsData?.has_more ?? true;
    const page = creatorsData?.page ?? 1;
    const creators = creatorsData?.items ?? [];
    const error = useSelector((state: RootState) => state.socialAccountState.creators.error);

    useEffect(() => {
        dispatch(setCreatorsFilters(defaultSocialAccountCreatorsFilters));
    }, [])

    useEffect(() => {
        if (socialAccountId && filters) {
            if (filters.page && filters.page === 1) {
                setInitialLoading(true);
            }
            if (debounceTimeout.current) {
                clearTimeout(debounceTimeout.current);
            }
            debounceTimeout.current = setTimeout(() => {
                dispatch(fetchSocialAccountCreatorsThunk({ socialAccountId, filters })).finally(() => {
                    setInitialLoading(false);
                    setFilterId(generateUniqueKey(filters, ['page']))
                })
            }, 500)
        }
    }, [socialAccountId, filters])

    const nextPage = () => {
        if (hasMore && socialAccountId && !loading) {
            const nextPageNumber = page + 1;
            dispatch(fetchSocialAccountCreatorsThunk({ filters: { ...filters, page: nextPageNumber }, socialAccountId }))
        }
    }

    return (
        <InfiniteScroll
            dataLength={creators.length}
            next={nextPage}
            hasMore={hasMore}
            loader={<></>}
            className="creator-grid"
        >
            {creators.map((creator, i) => (
                <div key={i}>
                    <CreatorCard creator={creator} />
                </div>
            ))}
            {
                (loading || initialLoading) && Array.from({ length: 4 }).map((_, i) => (
                    <Skeleton height={'270px'} className='w-100 d-block' />
                ))
            }
            {
                !(loading || initialLoading) && error &&
                <div className="py-3 d-flex justify-content-center align-items-center">
                    <button className="theme-btn theme-btn-sm btn-primary-outlined" onClick={nextPage}>Load More <i className='ms-2 fs-5 bx bx-refresh'></i></button>
                </div>
            }
            {
                !(loading || initialLoading) && creators.length === 0 &&
                <div className="d-flex w-100 justify-content-center align-items-center my-5">
                    <div className="length-zero my-5">
                        <h3>Currently there is no creator in your list</h3>
                    </div>
                </div>
            }
        </InfiniteScroll>
    )
}

export default SocialAccountCreators
